import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { visitsApi } from '../../api/lib/visits';
import { Visit, VisitFinishSetting } from '../../api/types/visits';

import { CreateVisitor } from '@/features/visitors/api/types/visitor';
import { visitsKeys } from '@/features/visits/api/query-keys/visits';

export const useCreateVisit = (onSuccess?: (data: Visit) => void) => {
  const { t } = useTranslation(['createVisit']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      visitors,
      expectedAt,
      finishesAt,
      destinationIds,
      hostId,
      visitFinishSetting,
      categoryId,
      description,
    }: {
      visitors: CreateVisitor[];
      expectedAt: string;
      finishesAt: string;
      destinationIds: number[];
      hostId: number | null;
      visitFinishSetting: VisitFinishSetting | null;
      categoryId: number;
      description?: string;
    }) =>
      visitsApi.createVisit(
        visitors,
        expectedAt,
        finishesAt,
        destinationIds,
        hostId,
        visitFinishSetting,
        categoryId,
        description,
      ),
    onSuccess: data => {
      queryClient.invalidateQueries({
        queryKey: visitsKeys.lists(),
      });

      toast.success(t('createVisit:success'));

      onSuccess?.(data);
    },
    onError: (error: ApiError) => {
      toast.error(error?.response.data?.message);
    },
  });
};
